<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务管理</el-breadcrumb-item>
          <el-breadcrumb-item>考勤记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">考勤记录</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.status"
                    placeholder="请选择考勤状态"
                  >
                    <el-option label="旷工" value="0"></el-option>
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="早退" value="2"></el-option>
                    <el-option label="迟到" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button type="primary" @click="exportList()" class="btn"
          >实做保安考勤明细导出</el-button
        >
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          ref="multipleTable"
        >
          <el-table-column label="保安姓名" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.bodyguardName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="signTime" label="日期" align="center">
          </el-table-column>
          <el-table-column label="上班打卡" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.signAtIn }}</span>
            </template>
          </el-table-column>
          <el-table-column label="下班打卡" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.signAtOut }}</div>
            </template>
          </el-table-column>
          <el-table-column label="打卡状态" align="center">
            <template slot-scope="scope">
              <span class="">{{ scope.row.signStatus }}</span>
              <!-- <span
                class="blueColor"
                v-if="
                  scope.row.signStatusIn == -1 && scope.row.signStatusOut == 1
                "
                >迟到</span
              >
              <span
                class="blueColor"
                v-if="
                  scope.row.signStatusIn == -1 && scope.row.signStatusOut == -2
                "
                >异常</span
              >
              <span
                class="yllColor"
                v-if="
                  scope.row.signStatusIn == 1 && scope.row.signStatusOut == -2
                "
                >早退</span
              >
              <span
                class="greenColor"
                v-if="
                  scope.row.signStatusIn == 1 && scope.row.signStatusOut == 1
                "
                >正常</span
              > -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      ruleForm: {
        status: "",
      },
      id: "",
      jobNo: "",
      tableData: [],
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.jobNo = this.$route.query.jobNo;
      this.getList();
    }
  },
  methods: {
    resetForm() {
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    exportList() {
      this.$confirm("是否导出数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            status: this.ruleForm.status,
            jobNo: this.jobNo,
            bodyguardId: this.id,
          };

          this.$axios
            .post("/admapi/job/bodyguardsignexport", param, {
              responseType: "blob",
            })
            .then((data) => {
              console.log(data);
              let val = new Blob([data.data], {
                type: "application/vnd.ms-excel;charset=utf-8",
              });
              let header = decodeURI(data.headers["content-disposition"]);
              console.log(header);
              if (header != "undefined") {
                let index = header.indexOf("''");
                let fileName = header.substring(index + 2, header.length);
                const url = window.URL.createObjectURL(val);
                const link = document.createElement("a");
                link.download = fileName; // 设置a标签的下载属性
                link.style.display = "none";
                link.href = url;
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
                document.body.removeChild(link);
              } else {
                // this.$message({
                //   message: data.respMsg,
                //   type: "error"
                // });
              }
            })
            .catch()
            .finally();
          // );
        })
        .catch(() => {});
    },
    getList() {
      let param = {
        status: this.ruleForm.status,
        bodyguardId: this.id,
        jobNo: this.jobNo,
      };
      this.$axios
        .post(`/admapi/job/jobsignlist`, param)
        .then(({ data }) => {
          this.tableData = data;
        })
        .catch()
        .finally();
    },
  },
};
</script>
